module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/new_era_mobile-23f09bced988b317ca29ef68b62e9b97.png";